import { BaseModel, IBaseModel } from "./BaseModel";
import { Round } from "./Round";
import { Cohort } from "./Cohort";
import {
    CurrencyType,
    ModelBlock,
    ModelContext,
    ModelVariableScope,
} from "./engine";
import { User } from "./User";
import { TimeHorizon } from "./TimeHorizon";
import { ColorGroup } from "./ColorGroup";

type SimulationConfigurationOptions = {
    allowSelfAdvance?: boolean;
    defaultPromptScope?: "Participant" | "Team";
    defaultModelVariableScope?: ModelVariableScope;
    currency?: CurrencyType;
};

export const defaultSimConfig: SimulationConfigurationOptions = {
    allowSelfAdvance: false,
    defaultPromptScope: "Participant",
    defaultModelVariableScope: ModelVariableScope.Team,
    currency: CurrencyType.USD,
};

export type SimulationShape = IBaseModel & {
    title: string;
    slug: string;
    config?: SimulationConfigurationOptions;
    rounds: Round[];
    description?: string;
    theme?: any;
    variants_count?: number;
    rounds_count?: number;
    weight: number;
    cohorts?: Cohort[];
    modelBlocks?: ModelBlock[];
    createdBy?: User;
    created_by_id?: string;
    timeHorizons?: TimeHorizon[];
    colorGroups?: ColorGroup[];
    estimated_time?: number;
    interactiveBlocks?: ModelBlock[];
    model_blocks_count?: number;
    interactive_blocks_count?: number;
    designColors?: App.Data.DesignColorData[];
    simModelContext?: ModelContext;
    simToolContexts?: ModelContext[];
};

export class Simulation extends BaseModel implements SimulationShape {
    constructor(data = null) {
        super();
        if (data) {
            this.setUp(data);
        }
    }

    setUp(data) {
        if (data) {
            for (let prop in data) {
                this[prop] = data[prop];
            }
        }
    }

    public static CLASSNAME: string = "Simulation";
    public static END_POINT: string = "/api/simulations/";

    title: string = "";
    slug: string = "";
    config?: SimulationConfigurationOptions = defaultSimConfig;
    rounds: Round[] = [];
    description?: string;
    theme?: any;
    variants_count?: number;
    rounds_count?: number;
    weight: number = 0;
    cohorts?: Cohort[];
    modelBlocks?: ModelBlock[];
    createdBy?: User;
    timeHorizons?: TimeHorizon[];
    colorGroups?: ColorGroup[];
    estimated_time?: number;
    interactiveBlocks?: ModelBlock[];
    designColors?: App.Data.DesignColorData[];
    simModelContext?: ModelContext;
    simToolContexts?: ModelContext[];
}
